import type { Location } from 'react-router';

const BLOCKED_PATHS = new Set(['/', '/auth/login']);
const DEFAULT_PATH = '/admin';

function isSafeRedirectPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

/**
 * Resolves a redirect path from location state.
 *
 * @param locationState - The location state object that may contain a `nextPathname` property
 * @returns The resolved redirect path, or the default path if no valid redirect target is found
 *
 * @remarks
 * If no valid redirect path is found or if the target is blocked, returns the DEFAULT_PATH.
 * The target path must pass the `isSafeRedirectPath` validation to be accepted.
 */
export function resolveRedirectPath(locationState: Location<any>['state'] | null): string {
  const target =
    typeof locationState?.nextPathname === 'string' ? locationState.nextPathname : null;

  if (target == null || BLOCKED_PATHS.has(target) || !isSafeRedirectPath(target)) {
    return DEFAULT_PATH;
  }

  return target;
}
